import { notification } from "antd";
import Api from "../../api";
import API_URL from "../../api/url";
import {
  setAbhaCreatedList,
  setAbhaCreatedListNew,
  setAbhaCardsLogs,
  setDECODEBASEData,
  setDownloadReport,
  setReportList,
  setAbhaCardsLogspagitation
} from "../Slices/abhaSlice";
import { downloadBase64ToPDF } from "../../utils";

export const abhaCreatedList = async (userInput, dispatch) => {
  try {
    const { params, user, limit, page, currentPage } = userInput;
    console.log("pageee", userInput);
    const res = await Api.post(
      API_URL.ABHA_CREATED_LIST,
      { ...userInput }
      // { params: { ...params, UserId: user.UserId, page: params.page, limit: limit } }
    );
    dispatch(
      setAbhaCreatedList({
        list: res.data.result,
        dataLength: res.data.dataLength
      })
    );
    return res;
  } catch (error) {
    notification["error"]({
      message: error.response?.data?.message || error.message
    });
    return error;
  }
};
export const abhaCreatedListNew = (params, user) => async (dispatch) => {
  try {
    const res = await Api.post(
      API_URL.ABHA_CREATED_LIST,
      { customToken: "false" },
      {
        params: {
          ...params,
          CardSlug: "abha-linked",
          CardName: "ABHA Address Linked"
        }
      }
    );
    dispatch(
      setAbhaCreatedListNew({
        list: res.data.result,
        dataLength: res.data.dataLength
      })
    );
    return res;
  } catch (error) {
    notification["error"]({
      message: error.response?.data?.message || error.message
    });
    return error;
  }
};
export const AbhaCardsLogs = async (userInput, dispatch) => {
  try {
    const { params, user, limit, page, currentPage } = userInput;
    const res = await Api.post(
      API_URL.PATIENT_ABHA_LIST,
      { ...userInput }
      // { params: { ...params, UserId: user.UserId, limit: limit, page: page } }
    );
    dispatch(
      setAbhaCardsLogs({
        list: res.data.result,
        total: res.data.dataLength
      })
    );
    return res;
  } catch (error) {
    notification["error"]({
      message: error.response?.data?.message || error.message
    });
    return error;
  }
};
export const ReportList = async (userInput, dispatch) => {
  try {
    const { params, user, limit, page, currentPage } = userInput;
    const res = await Api.post(
      API_URL.PATIENT_REPORT_LIST,
      { ...userInput }
      // params: { ...params, limit: limit, page: page },
    );
    dispatch(
      setReportList({ list: res.data.result, total: res.data.dataLength })
    );
    return res;
  } catch (error) {
    notification["error"]({
      message: error.response?.data?.message || error.message
    });
    return error;
  }
};
export const GetReportPdf = (data) => async (dispatch) => {
  try {
    const res = await Api.post(API_URL.GET_REPORT_PDF, data);
    // console.log(res.data);
    downloadBase64ToPDF(res.data?.result);
    return res;
  } catch (error) {
    notification["error"]({
      message: error.response?.data?.message || error.message
    });
    return error;
  }
};
export const KeyMaterialRequst =
  (data, navigate, healthId) => async (dispatch) => {
    try {
      const res = await Api.post(API_URL.HEALTH_INFORMATION_REQUEST, data);
      //   console.log(res, "==)_");

      notification["success"]({
        message: "Pull Data Successfully"
      });
      if (res.status === 202) {
        navigate(`/hiu/data-received`);
      }

      return res;
    } catch (error) {
      notification["error"]({
        message: error.response?.data?.message || error.message
      });
      return error;
    }
  };
export const DownloadReport = async (data, navigate) => {
  try {
    const res = await Api.post(API_URL.DOWNLOAD_REPORT, data);

    // navigate("");
    // notification["success"]({
    //   message: "Data Request Successfully"
    // });
    // const fhir_bundle = res.data.data;
    // console.log(fhir_bundle, "444");

    // dispatch(
    //   setDownloadReport({
    //     list: res.data.data
    //     // total: res.data.result.TotalRecord
    //   })
    // );
    return res;
  } catch (error) {
    notification["error"]({
      message: error.response?.data?.message || error.message
    });
    return error;
  }
};
export const DECODEBASE = (data, navigate) => async (dispatch) => {
  try {
    const res = await Api.post(API_URL.DECODE_BASE64, data, {
      headers: { token: "static" }
    });

    navigate("");
    notification["success"]({
      message: "Data Downloaded Successfully"
    });
    dispatch(
      setDECODEBASEData({
        list: res.data.result,
        total: res.data.result.TotalRecord
      })
    );
    return res;
  } catch (error) {
    notification["error"]({
      message: error.response?.data?.message || error.message
    });
    return error;
  }
};

export const AuditLogsData = async (data) => {
  try {
    const res = await Api.post(API_URL.AUDIT_LOGS, data);

    notification["success"]({
      message: "Audit Logs Successfully"
    });
    // dispatch(
    //   setAbhaCardsLogs({
    //     list: res.data.result,
    //     total: res.data.result.TotalRecord
    //   })
    // );
    return res;
  } catch (error) {
    notification["error"]({
      message: error.response?.data?.message || error.message
    });
    return error;
  }
};
